































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseOverlay from '@shared/components/@atoms/BaseOverlay/BaseOverlay.vue';
import { clickOutside } from '@shared/ui/utilities/directives';
import { isClient } from '@shared/ui/utilities/helpers';

export default defineComponent({
  name: 'BaseDropdown',
  components: {
    BaseOverlay,
    BaseButton,
  },
  directives: {
    clickOutside,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen: {
      handler(value) {
        if (!isClient) return;
        if (value) {
          document.addEventListener('keydown', this.keydownHandler);
        } else {
          document.removeEventListener('keydown', this.keydownHandler);
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.$emit('click:open');
    },
    close() {
      this.$emit('click:close');
    },
    checkPersistence() {
      if (!this.persistent) return this.close();
    },
    // @ts-ignore migrated from ui-library
    keydownHandler(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.close();
      }
    },
  },
});
